<template>
  <basic-container>
    <div
      class="path-container"
      style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px"
    >
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>设备管理</el-breadcrumb-item>
        <el-breadcrumb-item>健康数据</el-breadcrumb-item>
        <el-breadcrumb-item> 返回上一级</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- <div style="padding: 20px 0;">
      <div style="width: 100px; heigh: 100px; background-color: red">123</div>
    </div> -->

    <div>
      <avue-crud
        :option="option"
        :data="data"
        ref="crud"
        v-model="form"
        :permission="permissionList"
        :page.sync="page"
        @on-load="onLoad"
      >
        <template slot="menuLeft"> </template>
      </avue-crud>
    </div>
    <!-- 血压 -->
    <div>
      <div style="font-size: 20px; margin: 10px 0px">收缩压、舒张压表</div>
      <i style="margin-right: 4px" class="el-icon-time"></i>报告隶属时间段：
      <el-date-picker
        v-model="bpDate"
        value-format="yyyy-MM-dd HH:mm:ss"
        type="daterange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :readonly="false"
      >
      </el-date-picker>
      {{ "\u3000" }}
      <el-button type="primary" @click="bpSearch">搜索</el-button>
    </div>
    <div>
      <div id="bpChart" :style="{ width: '100%', height: '600px' }"></div>
    </div>
    <!-- 心率 -->
    <div>
      <div style="font-size: 20px; margin: 5px 0px">心率表</div>
      <i style="margin-right: 4px" class="el-icon-time"></i>报告隶属时间段：
      <el-date-picker
        v-model="heartDate"
        value-format="yyyy-MM-dd HH:mm:ss"
        type="daterange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :readonly="false"
      >
      </el-date-picker>
      {{ "\u3000" }}
      <el-button type="primary" @click="heartSearch">搜索</el-button>
      <div id="heartChart" :style="{ width: '100%', height: '600px' }"></div>
    </div>
    <!-- 血糖 -->
    <div>
      <div style="font-size: 20px; margin-top: 10px">血糖表</div>
      <i style="margin-right: 4px" class="el-icon-time"></i>报告隶属时间段：
      <el-date-picker
        v-model="bsDate"
        value-format="yyyy-MM-dd HH:mm:ss"
        type="daterange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :readonly="false"
      >
      </el-date-picker>
      {{ "\u3000" }}
      <el-button type="primary" @click="bsSearch">搜索</el-button>
    </div>
    <div>
      <div id="bsChart" :style="{ width: '100%', height: '600px' }"></div>
    </div>
    <!-- 血氧 -->
    <div>
      <div style="font-size: 20px; margin-top: 10px">血氧表</div>
      <i style="margin-right: 4px" class="el-icon-time"></i>报告隶属时间段：
      <el-date-picker
        v-model="boDate"
        value-format="yyyy-MM-dd HH:mm:ss"
        type="daterange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :readonly="false"
      >
      </el-date-picker>
      {{ "\u3000" }}
      <el-button type="primary" @click="boSearch">搜索</el-button>
    </div>
    <div>
      <div id="boChart" :style="{ width: '100%', height: '600px' }"></div>
    </div>
    <!-- 温度 -->
    <div>
      <div style="font-size: 20px; margin-top: 10px">体温表</div>
      <i style="margin-right: 4px" class="el-icon-time"></i>报告隶属时间段：
      <el-date-picker
        v-model="btDate"
        value-format="yyyy-MM-dd HH:mm:ss"
        type="daterange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :readonly="false"
      >
      </el-date-picker>
      {{ "\u3000" }}
      <el-button type="primary" @click="btSearch">搜索</el-button>
    </div>
    <div>
      <div id="btChart" :style="{ width: '100%', height: '600px' }"></div>
    </div>
    <!-- 运动 -->
    <div>
      <div style="font-size: 20px; margin-top: 10px">运动表</div>
      <i style="margin-right: 4px" class="el-icon-time"></i>报告隶属时间段：
      <el-date-picker
        v-model="moDate"
        value-format="yyyy-MM-dd HH:mm:ss"
        type="daterange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :readonly="false"
      >
      </el-date-picker>
      {{ "\u3000" }}
      <el-button type="primary" @click="moSearch">搜索</el-button>
    </div>
    <div>
      <div id="moChart" :style="{ width: '100%', height: '600px' }"></div>
    </div>
  </basic-container>
</template>

<script>
import { heDataValueNew, bpDataValueNew } from "../../api/health/bpmeterdata";
import {
  bsDataValueNew,
  boDataValueNew,
  btDataValueNew,
  moDataValueNew,
} from "../../api/health/datashow";
import { getRecentData } from "@/api/health/manage";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      bpDate: [],
      heartDate: [],
      bsDate: [],
      boDate: [],
      btDate: [],
      moDate: [],
      form: {},
      params: {
        wxUserId: "",
        week: "",
        type: "1",
        jkStatus: "",
        beginDate: "",
        endDate: "",
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        tip: false,
        border: true,
        viewBtn: true,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        menu: false,
        column: [
          {
            label: "数据更新时间",
            prop: "date",
            width: 170,
          },
          {
            label: "BMI",
            prop: "bmi",
          },
          {
            label: "舒张压",
            prop: "dia",
            formatter: (row) => {
              return row.dia ? `${row.dia} mmHg` : "";
            },
          },
          {
            label: "收缩压",
            prop: "sys",
            formatter: (row) => {
              return row.sys ? `${row.sys} mmHg` : "";
            },
          },
          {
            label: "心率",
            prop: "heart",
            formatter: (row) => {
              return row.heart ? `${row.heart} bpm` : "";
            },
          },
          {
            label: "血氧",
            prop: "bo",
            formatter: (row) => {
              return row.bo ? `${row.bo} %` : "";
            },
          },
          {
            label: "皮肤温度",
            prop: "bt",
            formatter: (row) => {
              return row.bt ? `${row.bt} ℃` : "";
            },
          },
          {
            label: "血糖",
            prop: "bs",
            formatter: (row) => {
              return row.bs ? `${row.bs} mmol/L` : "";
            },
          },
          {
            label: "尿酸",
            prop: "ua",
            formatter: (row) => {
              return row.ua ? `${row.ua} μmol/L` : "";
            },
          },
          {
            label: "胆固醇",
            prop: "cholesterol",
            formatter: (row) => {
              return row.cholesterol ? `${row.cholesterol} mmol/L` : "";
            },
          },
          {
            label: "心电图",
            prop: "ecg",
            width: 120,
          },
          {
            label: "睡眠",
            prop: "sleep",
          },
          {
            label: "情绪压力",
            prop: "pressure",
          },
          {
            label: "运动(步数)",
            prop: "mo",
          },
          {
            label: "中医体质",
            prop: " ",
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.permission.health_userjk_add,
        viewBtn: this.permission.health_userjk_view,
        delBtn: this.permission.health_userjk_delete,
        editBtn: this.permission.health_userjk_edit,
      };
    },
    ids() {
      const ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  created() {
    this.params.wxUserId = this.$route.query.wxUserId || ""; // eslint-disable-line no-unused-vars
    this.params.week = this.$route.query.meterDate || ""; // eslint-disable-line no-unused-vars
    this.params.jkStatus = this.$route.query.jkStatus || "";
    this.params.beginDate = this.$route.query.beginDate || "";
    this.params.endDate = this.$route.query.endDate || "";
  },
  methods: {
    onLoad(o) {
      const wxUserId = this.$route.query.wxUserId;
      getRecentData(wxUserId).then((res) => {
        if (res.data.length !== 0) this.data = res.data;
      });
      bpDataValueNew(this.params).then((res) => {
        this.bpLine(res.data);
      });
      heDataValueNew(this.params).then((res) => {
        this.heartLine(res.data);
      });
      bsDataValueNew(this.params).then((res) => {
        this.bsLine(res.data);
      });
      boDataValueNew(this.params).then((res) => {
        this.boLine(res.data);
      });
      btDataValueNew(this.params).then((res) => {
        this.btLine(res.data);
      });
      moDataValueNew(this.params).then((res) => {
        this.moLine(res.data);
      });
    },

    bpSearch(data) {
      if (this.bpDate == null) {
        this.params.beginDate = "";
        this.params.endDate = "";
      } else {
        this.params.beginDate = this.bpDate[0] || "";
        this.params.endDate = this.bpDate[1] || "";
      }
      bpDataValueNew(this.params).then((res) => {
        this.bpLine(res.data);
      });
    },

    heartSearch(data) {
      if (this.heartDate == null) {
        this.params.beginDate = "";
        this.params.endDate = "";
      } else {
        this.params.beginDate = this.heartDate[0] || "";
        this.params.endDate = this.heartDate[1] || "";
      }
      heDataValueNew(this.params).then((res) => {
        this.heartLine(res.data);
      });
    },

    bsSearch(data) {
      if (this.bsDate == null) {
        this.params.beginDate = "";
        this.params.endDate = "";
      } else {
        this.params.beginDate = this.bsDate[0] || "";
        this.params.endDate = this.bsDate[1] || "";
      }
      bsDataValueNew(this.params).then((res) => {
        this.bsLine(res.data);
      });
    },

    boSearch(data) {
      if (this.boDate == null) {
        this.params.beginDate = "";
        this.params.endDate = "";
      } else {
        this.params.beginDate = this.boDate[0] || "";
        this.params.endDate = this.boDate[1] || "";
      }
      boDataValueNew(this.params).then((res) => {
        this.boLine(res.data);
      });
    },

    btSearch(data) {
      if (this.btDate == null) {
        this.params.beginDate = "";
        this.params.endDate = "";
      } else {
        this.params.beginDate = this.btDate[0] || "";
        this.params.endDate = this.btDate[1] || "";
      }
      btDataValueNew(this.params).then((res) => {
        this.btLine(res.data);
      });
    },

    moSearch(data) {
      if (this.moDate == null) {
        this.params.beginDate = "";
        this.params.endDate = "";
      } else {
        this.params.beginDate = this.moDate[0] || "";
        this.params.endDate = this.moDate[1] || "";
      }
      moDataValueNew(this.params).then((res) => {
        this.moLine(res.data);
      });
    },

    heartLine(list) {
      const myChart = this.$echarts.init(document.getElementById("heartChart"));
      // 绘制图表
      myChart.setOption({
        title: {
          text: "心率数据折现变化图",
          subtext: "单位:次/分钟",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["心率"],
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: list.map((v) => v.meterDate),
        },
        yAxis: {
          type: "value",
          min: 0,
          axisLabel: {
            formatter: "{value} 次",
          },
        },
        series: [
          {
            name: "心率",
            type: "line",
            data: list.map((v) => v.avgHeartRate),
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" },
              ],
            },
            markLine: {
              data: [{ type: "average", name: "平均值" }],
            },
          },
        ],
      });
    },

    bpLine(list) {
      const myChart = this.$echarts.init(document.getElementById("bpChart"));
      // 绘制图表
      myChart.setOption({
        title: {
          text: "血压数据折现变化图",
          subtext: "单位:mmHg",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["收缩压", "舒张压"],
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: list.map((v) => v.meterDate),
        },
        yAxis: {
          type: "value",
          min: 40,
          axisLabel: {
            formatter: "{value} mmHg",
          },
        },
        series: [
          {
            name: "收缩压",
            type: "line",
            data: list.map((v) => v.avgSystolic),
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" },
              ],
            },
            markLine: {
              data: [{ type: "average", name: "平均值" }],
            },
          },
          {
            name: "舒张压",
            type: "line",
            data: list.map((v) => v.avgDiastolic),
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" },
              ],
            },
            markLine: {
              data: [
                { type: "average", name: "平均值" },
                [
                  {
                    symbol: "none",
                    x: "90%",
                    yAxis: "max",
                  },
                  {
                    symbol: "circle",
                    label: {
                      position: "start",
                      formatter: "最大值",
                    },
                    type: "max",
                    name: "最高点",
                  },
                ],
              ],
            },
          },
        ],
      });
    },

    bsLine(list) {
      const myChart = this.$echarts.init(document.getElementById("bsChart"));
      // 绘制图表
      myChart.setOption({
        title: {
          text: "血糖数据折现变化图",
          subtext: "单位:mmol/L",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["血糖"],
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: list.map((v) => v.meterDate),
        },
        yAxis: {
          type: "value",
          min: 0,
          axisLabel: {
            formatter: "{value} mmol/L",
          },
        },
        series: [
          {
            name: "血糖",
            type: "line",
            data: list.map((v) => v.avgBsValue),
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" },
              ],
            },
            markLine: {
              data: [{ type: "average", name: "平均值" }],
            },
          },
        ],
      });
    },

    boLine(list) {
      const myChart = this.$echarts.init(document.getElementById("boChart"));
      // 绘制图表
      myChart.setOption({
        title: {
          text: "血氧数据折现变化图",
          subtext: "单位:%",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["血氧"],
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: list.map((v) => v.meterDate),
        },
        yAxis: {
          type: "value",
          min: 0,
          axisLabel: {
            formatter: "{value} %",
          },
        },
        series: [
          {
            name: "血氧",
            type: "line",
            data: list.map((v) => v.avgBoValue),
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" },
              ],
            },
            markLine: {
              data: [{ type: "average", name: "平均值" }],
            },
          },
        ],
      });
    },

    btLine(list) {
      const myChart = this.$echarts.init(document.getElementById("btChart"));
      // 绘制图表
      myChart.setOption({
        title: {
          text: "体温数据折现变化图",
          subtext: "单位:℃",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["体温"],
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: list.map((v) => v.meterDate),
        },
        yAxis: {
          type: "value",
          min: 0,
          axisLabel: {
            formatter: "{value} ℃",
          },
        },
        series: [
          {
            name: "体温",
            type: "line",
            data: list.map((v) => v.avgBtValue),
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" },
              ],
            },
            markLine: {
              data: [{ type: "average", name: "平均值" }],
            },
          },
        ],
      });
    },

    moLine(list) {
      const myChart = this.$echarts.init(document.getElementById("moChart"));
      // 绘制图表
      myChart.setOption({
        title: {
          text: "运动数据折现变化图",
          subtext: "单位:步",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["步数"],
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: list.map((v) => v.meterDate),
        },
        yAxis: {
          type: "value",
          min: 0,
          axisLabel: {
            formatter: "{value} 步",
          },
        },
        series: [
          {
            name: "步数",
            type: "line",
            data: list.map((v) => v.avgMoValue),
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" },
              ],
            },
            markLine: {
              data: [{ type: "average", name: "平均值" }],
            },
          },
        ],
      });
    },
  },
};
</script>
